<template>
    <div id="app">
        <Nav ref="nav" />
        <router-view></router-view>
        <router-view name="dialog"></router-view>
        <UserControls :showSetup="true" @accAnnouncementClick="showAccAnnouncement" />
        <StatusBar />
        <Footer />
        <UpdateChecker />
        <ReCalculateDialog />
        <NetworkDiagnosticDialog />
        <host-change-warning v-if="isFromOldDomain" />
        <AnnouncementDialog :visible="announcementDialogVisible" @close="onAnnouncementDialogClose" />
    </div>
</template>
<script>
import moment from 'moment';
import UpdateChecker from '@/components/UpdateChecker.vue';
import HostChangeWarning from '@/components/ui/HostChangeWarning.vue';
import Nav from './Nav.vue';
import UserControls from './UserControls.vue';
import StatusBar from './StatusBar.vue';
import Footer from './Footer.vue';
import ReCalculateDialog from './ReCalculateDialog.vue';
import NetworkDiagnosticDialog from './NetworkDiagnosticDialog.vue';
import AnnouncementDialog from './AccountingCenterAnnouncementDialog.vue';
import { isMobile } from '../../mixins/index';

export default {
    name: 'DashboardView',
    components: {
        UpdateChecker,
        Nav,
        UserControls,
        StatusBar,
        Footer,
        ReCalculateDialog,
        NetworkDiagnosticDialog,
        HostChangeWarning,
        AnnouncementDialog,
    },
    data() {
        return {
            ReCalculateDialogVisible: true,
            announcementDialogVisible: false,
        };
    },
    computed: {
        isFromOldDomain() {
            return window.location.host.indexOf('ahoo.tw') !== -1;
        },
    },
    mounted() {
        // 載入/更新 store 中給全域使用的參數
        this.$store.dispatch('cny/updateCnyOptions');
        this.$store.dispatch('statement/updateStatementOptions');
        this.$store.dispatch('bankAccount/updateBankAccountOptions');

        this.checkWetherShowAccAnnouncement();
    },
    methods: {
        showAccAnnouncement() {
            this.announcementDialogVisible = true;
        },
        checkWetherShowAccAnnouncement() {
            // 手機不顯示公告
            if (isMobile()) {
                return;
            }
            // 螢幕寬度小於 920 不顯示
            if (window.innerWidth <= 920) {
                return;
            }
            // 會計專區公告 2024-10-28 後開始
            if (moment().isBefore('2024-10-28')) {
                return;
            }
            // 有下面權限任一才看得見公告：填寫付款明細(A02)、確認付款(A03)、分析/營業收支總覽(D11)
            if (!this.isAuthOne(['A02', 'A03', 'D11'])) {
                return;
            }
            // 確認是否已勾選過不再顯示（LocalStorage）
            if (localStorage.getItem('not-display-acc-annoucement') === '1') {
                return;
            }
            // 顯示公告
            this.announcementDialogVisible = true;
        },
        onAnnouncementDialogClose() {
            this.announcementDialogVisible = false;
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/main.scss";
</style>
